// extracted by mini-css-extract-plugin
export default {"container":"ConfirmationForgotPassword_container__KhLIv","content":"ConfirmationForgotPassword_content__vTBxK"};